module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Electric/Highvoltage-c8988ed468050b42cebb0281774d8ddf.svg";